/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import ConfirmDialogButton from './confirm-dialog-button';

import { Form, Input } from 'semantic-ui-react';

import QueuesSelector from '../widgets/queues-selector';
import ServicesSelector from '../widgets/services-selector';
import { Label } from '../forms/fields';

interface AssignButtonActionDialogButtonState {
  id: string;
  queueId: any;
  serviceId: string;
  name: string;
  touched: boolean;
  action: string;
}
interface AssignButtonActionDialogButtonProps {
  queues: any;
  services: any;
  onModalConfirm: any;
  buttonLabel?: string;
  buttonDisabled: boolean;
  modalTitle?: string;
  modalSubtitle?: string;
}
export default class AssignButtonActionDialogButton extends React.Component<
  AssignButtonActionDialogButtonProps,
  AssignButtonActionDialogButtonState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      id: '',
      action: 'add-ticket',
      queueId: '',
      serviceId: '',
      name: '',
      touched: false
    };
  }
  handleIdChange = (event: any, data: any) => {
    this.setState({ id: data.value });
  };
  handleNameChange = (event: any, data: any) => {
    this.setState({ name: data.value });
  };
  handleQueueChange = (event: any, data: any) => {
    this.setState({ queueId: data.value });
  };

  handleServiceChange = (event: any, data: any) => {
    this.setState({ serviceId: data.value });
  };

  confirmModal() {
    const { id, action, queueId, serviceId, name }: any = this.state;
    this.props.onModalConfirm({ id, action, queueId, serviceId, name });
    this.setState({ id: '', queueId: '' });
    return true;
  }
  isValid() {
    return this.state.id && this.state.queueId;
  }

  showError() {
    return this.state.touched && !this.isValid();
  }

  override render() {
    return (
      <ConfirmDialogButton
        {...this.props}
        onModalConfirm={() => this.confirmModal()}
        confirmDisabled={!this.isValid()}
      >
        <div>
          <h3>Add ticket to queue action:</h3>
          <Form>
            <Form.Field>
              <Label>Button Id</Label>
              <Input value={this.state.id} onChange={this.handleIdChange} />
            </Form.Field>
            <Form.Field>
              <Label>Assign Queue</Label>
              <QueuesSelector
                multiple={false}
                items={this.props.queues}
                value={this.state.queueId}
                onChange={this.handleQueueChange}
              />
              <Label>Assign Service</Label>
              <ServicesSelector
                multiple={false}
                items={this.props.queues}
                value={this.state.serviceId}
                onChange={this.handleServiceChange}
              />
              <Form.Field>
                <Label>Assign Button Name</Label>
                <Input
                  value={this.state.name}
                  onChange={this.handleNameChange}
                />
              </Form.Field>
            </Form.Field>
            <div style={{ height: '200px' }}></div>
            {this.showError() && (
              <div style={{ color: 'red' }}>
                Button id and queue are required!
              </div>
            )}
          </Form>
        </div>
      </ConfirmDialogButton>
    );
  }
}
